export function removeParameterFromUrl (url = '', parameter = '') {
  url = new URL(url)
  const params = new URLSearchParams(url.hash.slice(url.hash.indexOf('?')))
  params.delete(parameter)
  url.hash = `${url.hash.slice(0, url.hash.indexOf('?'))}?${params}`
  return url.href
}
